module.exports = __webpack_public_path__ + "static/media/212.70705824.webp";